import React, { useState }  from 'react';
import { useSelector }      from 'react-redux';
import { Button }           from 'react-bootstrap';
import { ICON_INFO }        from '../../extras/icons';
import judgeSelectionType   from '../../../data/judgeSelectionType';
import MotivoResorteo       from '../work/scheduling/forms/MotivoResorteo';



const JudgesInfo = () => {

    // ==========================================================================================
    // CARGA DE VALORES -------------------------------------------------------------------------
    // ==========================================================================================
    const audience = useSelector(state => state.audiences.audienceWork);
    const user = useSelector(state => state.auth.user);
    
    

    // ==========================================================================================
    // DECLARACIONES ----------------------------------------------------------------------------
    // ==========================================================================================    
    const [datosJuez, setDatosJuez] = useState(''); 
    const [showMotivo, setShowMotivo] = useState(false);
    
    
    
    // ==========================================================================================
    // FUNCIONES --------------------------------------------------------------------------------
    // ==========================================================================================

    // Manejo el cierre de la ventana
    const handleCloseMotivo = () => {
        setShowMotivo(false);
    }
    // Muestra el modal
    const mostrarMotivo = (juez) => {
        setDatosJuez(juez);
        setShowMotivo(true);
    }

    // ==========================================================================================
    // RENDERIZO --------------------------------------------------------------------------------
    // ==========================================================================================    
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">JUEZ/CES SELECCIONADO/S</h6>
                </div>
                <table className="table table-hover table-sm">
                    <thead>
                        <tr className="table-light">
                            <th className="text-center">#</th>
                            <th className="text-center">Apellido y Nombre</th>
                            <th className="text-center">Tipo de selección</th> 
                            <th className="text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {   audience.audienciaJuezList && audience.audienciaJuezList.length > 0 
                                ?
                                    audience.audienciaJuezList.filter(judge => judge.anulado === 0 || (judge.anulado===1 && user.ofiju?.nombre==='IMPUGNACIÓN' && user.perfil?.descripcion==='Juez') ).map((judge, index) => (
                                        <tr key={`asaaj${judge.id}`} className={judge.anulado === 1 ? 'table-danger' : ''}>
                                            <td className="align-middle text-center">
                                                { index + 1 }
                                            </td>
                                            <td className="align-middle text-center">
                                                { judge.juez.apellido + ', ' + judge.juez.nombre }
                                            </td>
                                            <td className="align-middle text-center">
                                                {   judge.tipo > 0 && judgeSelectionType.find( type => type.id === judge.tipo) 
                                                        ?
                                                            judgeSelectionType.find( type => type.id === judge.tipo).descripcion
                                                        : 
                                                            null
                                                }
                                            </td>                                            
                                            <td className="align-middle text-center">
                                                {   (judge.anulado===1) && (judge.motivo!==null)
                                                        ? 
                                                            <Button
                                                                onClick = { () => mostrarMotivo(judge) }
                                                                size = "sm" 
                                                                variant = "info" 
                                                            >
                                                                <ICON_INFO />
                                                            </Button>
                                                        :
                                                            null   
                                                }
                                            </td>
                                        </tr>
                                    ))
                                : 
                                    null
                        }
                    </tbody>
                </table>
            </div>

            <MotivoResorteo
                datosJuez = { datosJuez }
                handleClose = { handleCloseMotivo }
                show = { showMotivo }
            />

        </div>
    );
};

export default JudgesInfo;